import { Box } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { fetchController } from "../../../utils/FetchController/fetchController";
import Loader from "../../../utils/Loader/Loader";
import { getHostDomain } from "../../../utils/utils";

const endpoint = "/api/v1/billing/create-checkout-session";

// Landing page after Stripe Checkout redirects back. Two flows hit this:
//   1. Add/Update card (wallet bar "Update card") — setup-only session,
//      no lookup_key in the URL. Nothing left to do on the backend; just
//      bounce the user back to billing.
//   2. Card added mid-subscription flow — the original /add-payment-method
//      call carried a lookup_key, so we now create the actual subscription
//      checkout session and forward the user to Stripe.
const BillingSuccess = () => {
  const baseUrl = getHostDomain();
  const navigate = useNavigate();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const lookupKey = queryParams.get("lookup_key");

  const [message, setMessage] = useState(
    lookupKey ? "Setting up your plan…" : "Saving your payment method…"
  );

  useEffect(() => {
    finishFlow();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const finishFlow = async () => {
    if (!lookupKey) {
      toast.success("Payment method saved.");
      navigate("/settings/billing", { replace: true });
      return;
    }
    try {
      const res = await fetchController(baseUrl + endpoint, "POST", {
        lookup_key: lookupKey,
      });
      if (res?.checkout_url) {
        window.location.href = res.checkout_url;
        return;
      }
      toast.success(res?.message || "Plan updated.");
    } catch (err) {
      console.error("Error finishing plan upgrade:", err);
      toast.error("Could not finish the plan upgrade. Please try again.");
    } finally {
      setMessage("Redirecting…");
      navigate("/settings/billing", { replace: true });
    }
  };

  return (
    <Box textAlign="center" marginTop="50px">
      <Loader text={message} />
    </Box>
  );
};

export default BillingSuccess;
